export default "__VITE_ASSET__BL9Mzz_C__"